




























































import {Component, Prop, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import TextField from "@/components/inputs/TextField.vue";
import SeoText from "@/components/inputs/SeoText.vue";
import Seo from "@/components/inputs/Seo.vue";
import Editor from '@tinymce/tinymce-vue';
import {ActionsEnum} from "@/entity/ActionsEnum";
import Id from "@/components/inputs/Id.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import Number from "@/components/inputs/Number.vue";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import PageEntity from "@/entity/PageEntity";
import RichTextEditor from "@/components/RichTextEditor.vue";
import ImagesEntity from "@/entity/ImagesEntity";
import {PageTypeEnum} from "@/entity/PageTypeEnum";

@Component({
    components: {RichTextEditor, DeleteButton, Number, ImageUpload, Id, Seo, SeoText, TextField, EForm,Editor}
})
export default class SayfaDetay extends Vue {
    title = "";
    dialog:boolean=false;
    uploadRequired = true;
    baseAction:string = ActionsEnum.Pages;
    pageAction:string = "";
    action:string = "";
    imagesAction:string = ActionsEnum.Images;
    data:PageEntity = new PageEntity();
    images:ImagesEntity[] = [];
    image:ImagesEntity = new ImagesEntity();
    async get(){
        if(arguments.length > 0){
            this.$route.params.page_id = arguments[0].page_id;
        }
        if(this.$route.params.page_id == "ekle"){
            this.pageAction = this.baseAction;
        }else{
            this.pageAction = this.baseAction + "/" + this.$route.params.page_id ;
            let response = await this.$http.get(this.baseAction + "/" + this.$route.params.page_id);
            this.data = response.data;
        }
      this.data.type = this.$route.params.type;
    }
    async getImages(){
        if(this.$route.params.page_id != "ekle"){
            let response = await this.$http.get(this.imagesAction + "/" + this.$route.params.page_id);
            this.images = response.data;
        }
    }
    successAddedPage(data:any){
      console.log("data",data);
      this.$store.dispatch("go","/genel/sayfa/" + this.$route.params.type + "/" + data.page_id);
    }


    created(){
        console.log("created sayfa detay");
        this.get();
        this.getImages()
    }
    addImage(){
        this.action = this.imagesAction;
        this.uploadRequired = true;
        this.title = "Resim Ekle";
        this.image = new ImagesEntity();
        this.image.page_id = parseInt(this.$route.params.page_id);
        this.dialog = true;
    }
    editImage(item:ImagesEntity){
        this.title = "Resim " + item.title + " düzenle";
        this.action = this.imagesAction + "/" + item.image_id;
        this.uploadRequired = false;
        this.image = item;
        this.dialog = true;
    }
}
